<template>
  <div>
    <modal :name="modalName" :click-to-close="true" :height="'auto'" :scrollable="true">
      <v-modal-content v-on:close="close" :title="modalMode === 'add' ? loc('addUser') : loc('editUser') ">
        <v-form :fields="fields" :form-data="formData" :form-errors="formErrors">
          <div slot="buttons" class="v-form-button-div">
            <button class="btn btn--cancel" type="button" v-on:click="close">{{loc('cancel')}}</button>
            <button v-if="modalMode === 'add'" type="submit" v-on:click="addUser" class="btn btn--white">{{loc('addUser')}}</button>
            <button v-if="modalMode === 'edit'" type="submit" v-on:click="updateUser" class="btn btn--white">{{loc('updateUser')}}</button>
          </div>
        </v-form>
      </v-modal-content>
    </modal>
  </div>
</template>

<script>

import VModalContent from './v-modal-content.vue';
import VForm from './v-form.vue';

export default {
  components: {
    'v-modal-content': VModalContent,
    'v-form': VForm
  },
  name: 'ModalUser',
  props: ['on-close', 'modal-mode', 'modal-data'],
  data: function() {
    return {
      formErrors: {},
      formData: {},
      name: 'user',
      showCount: 0,
      data: {}
    }
  },
  computed: {
    fields() {
      // Refresh when countries load
      if(this.$store.getters.countrySelectOptions) {
        return this.getFields();
      }
    },
    modalName() {
      return this.name + ' ' + this.modalMode;
    },
    canEditRole() {
      // Can not change own role
      return this.data.id !== this.$store.state.user.info.id;
    }
  },
  methods: {
    applyModalData() {
      this.formErrors = {};
      this.formData = {};
      this.data = {};

      if(this.$props.modalData) {
        Object.keys(this.$props.modalData).forEach(key => {
          this.data[key] = this.$props.modalData[key];
        });
      }

      this.increaseShowCount();
    },
    increaseShowCount() {
      this.showCount++;
    },
    getFields() {
      // Refresh data when showCount is increased
      this.showCount;

      // Initialize form depending on modal mode
      if(this.$props.modalMode === 'add') {
        return [{
          name: 'firstName',
          value: '',
          label: this.loc('firstName'),
          type: 'text'
        }, {
          name: 'lastName',
          value: '',
          label: this.loc('lastName'),
          type: 'text'
        }, {
          name: 'username',
          value: '',
          label: this.loc('forms.labels.username'),
          type: 'email'
        }, {
          name: 'company',
          value: this.data.companyId,
          label: '',
          type: 'hidden'
        }, {
          name: 'phone',
          value: '',
          label: this.loc('phone'),
          type: 'text'
        }, {
          name: 'role',
          value: '',
          label: this.loc('forms.labels.role'),
          options: [{
            value: 'retailer',
            text: this.loc('roles.retailer')
          }, {
            value: 'retailer-admin',
            text: this.loc('roles.retailerAdmin')
          }],
          type: 'select'
        }, {
          name: 'country',
          value: this.data.countryCode || '',
          label: this.loc('country'),
          options: this.$store.getters.countrySelectOptions,
          type: 'select'
        }];
      } else if(this.$props.modalMode === 'edit') {
        return [{
          name: 'id',
          value: this.data.id,
          type: 'hidden'
        }, {
          name: 'firstName',
          value: this.data.firstName,
          label: this.loc('firstName'),
          type: 'text'
        }, {
          name: 'lastName',
          value: this.data.lastName,
          label: this.loc('lastName'),
          type: 'text'
        }, {
          name: 'phone',
          value: this.data.phone,
          label: this.loc('phone'),
          type: 'text'
        }, {
          name: 'role',
          value: this.data.role,
          label: this.loc('forms.labels.role'),
          options: [{
            value: 'retailer',
            text: this.loc('roles.retailer')
          }, {
            value: 'retailer-admin',
            text: this.loc('roles.retailerAdmin')
          }],
          type: this.canEditRole ? 'select' : 'hidden'
        }, {
          name: 'country',
          value: this.data.country && this.data.country.countryCode || '',
          label: this.loc('country'),
          options: this.$store.getters.countrySelectOptions,
          type: 'select'
        }];
      }
    },
    show() {
      this.$store.dispatch('getCountries');
      this.applyModalData();
      this.$modal.show(this.modalName);
    },
    close(data) {
      if(this.onClose) {
        if(!data) {
          data = {
            status: 'cancel'
          };
        }
        this.onClose(data);
      }
      this.$modal.hide(this.modalName);
    },
    addUser() {
      const self = this;
      return this.$api.addUser(this.formData).then(res => {

        // Errors in form
        if(res.code === 400) {
          this.formErrors = res.result.fields;
        }

        if(res.code === 200) {
          self.$store.commit('addUser', res.result.user);
          self.close({status: 'success'});
          this.sendNewUserMail(res.result.user)
        }
      });
    },
    async sendNewUserMail(data) {
      if(!this.token) {
        const tokenRes = await this.$api.getToken();
        if(tokenRes.code === 200) {
          this.token = tokenRes.result.token;
        }
      }

      return this.$api.registerPassword({
        token: this.token,
        username: data.username
      })
      .then(res => {
        this.token = '';

        // Errors in form
        if(res.code === 400) {
          this.formErrors = res.result.fields;
        }

        if(res.code === 200) {
          this.passwordSent = true;
        }
      });
    },
    updateUser() {
      const self = this;
      return this.$api.updateUser(this.formData.id, this.formData).then(res => {

        // Errors in form
        if(res.code === 400) {
          this.formErrors = res.result.fields;
        }

        if(res.code === 200) {
          self.$store.commit('updateUser', res.result.user);
          self.close({status: 'success'});
        }
      });
    }
  },
  watch: {
    modalData() {
      this.applyModalData();
    }
  }
}
</script>
